module.exports = __webpack_public_path__ + "static/media/alernativeAC84758131.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/alernativeAC.svg
// module id = 1314
// module chunks = 0